import type { IStockRepository, BatchesAtWarehouseOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockBatchEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListBatchesAtWarehouseUseCase({ stockRepository }: Deps) {
  return async function listBatchesAtWarehouse(options: BatchesAtWarehouseOptions): Promise<StockBatchEntity[]> {
    return stockRepository.listBatchesAtWarehouse(options);
  };
}
